import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { SelectItem } from '@openng/optimus-ui/api';
import { Panel } from '@openng/optimus-ui/panel';
import { InputText } from '@openng/optimus-ui/inputtext';
import { Select } from '@openng/optimus-ui/select';
import { InputMask } from '@openng/optimus-ui/inputmask';
import { ButtonDirective } from '@openng/optimus-ui/button';
import { Tooltip } from '@openng/optimus-ui/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { BaseComponent } from 'src/app/core/components/base.component';
import { CommercialContact } from 'src/app/model/commercial-services/commercial-contact';
import { InlineValidationComponent } from 'src/app/core/components/inline-validation.component';

@Component({
  selector: 'app-commercial-contact-form',
  templateUrl: './commercial-contact-form.component.html',
  styleUrls: ['./commercial-contact-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    Panel,
    InputText,
    Select,
    InputMask,
    ButtonDirective,
    Tooltip,
    TranslatePipe,
    InlineValidationComponent,
  ],
})
export class CommercialContactFormComponent extends BaseComponent {
  readonly form = input<UntypedFormGroup>();
  readonly contact = input<CommercialContact | null>(null);
  readonly availableCompanies = input<SelectItem[]>([]);
  readonly availableJobRoles = input<SelectItem[]>([]);
  readonly writeAccess = input(false);

  readonly phoneMask = '+1-999-999-9999';
}
